<template>
  <div
    v-if="has_perm('view_invoice') || GET_ACCOUNT_DATA.id == 1"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>

          <div class="box-body">
            <div v-if="onTabSelect === TAB_ITEMS.HISTORY" class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon"><i class="fa fa-text-width"></i></span>
                  <input
                    v-on:keyup.enter="onSearchInvoice(defaultPage)"
                    type="text"
                    class="form-control"
                    :placeholder="$t('common.search')"
                    v-model="invoiceHistorySearch.searchText"
                  />
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="input-group">
                  <span class="input-group-addon">
                    <i class="fa fa-user"></i>
                  </span>
                  <input
                    v-on:keyup.enter="onSearchInvoice(defaultPage)"
                    type="text"
                    class="form-control"
                    :placeholder="$t('invoice.userCreated')"
                    v-model="invoiceHistorySearch.userCreatedName"
                  />
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;">{{ $t("service_history.date_from") }}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      v-model="invoiceHistorySearch.dateFrom">
                    </date-picker>
                  </div>
                </div>
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar">
                        <label>
                          <span style="margin-left:5px;display:inline-block;">{{ $t("service_history.date_to") }}:</span>
                        </label>
                      </i>
                    </div>
                    <date-picker
                      :config="options"
                      v-model="invoiceHistorySearch.dateTo">
                    </date-picker>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-paperclip"></i>
                    </span>
                    <input
                      v-on:keyup.enter="onSearchInvoice(defaultPage)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('invoice.invoice_number')"
                      v-model="search.invoice_number"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group">
                    <span class="input-group-addon">
                      <i class="fa fa-home"></i>
                    </span>
                    <input
                      v-on:keyup.enter="onSearchInvoice(defaultPage)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('invoice.apartment_code')"
                      v-model="search.apartment_code"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-user"></i>
                    </div>
                    <input
                      v-on:keyup.enter="onSearchInvoice(defaultPage)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('invoice.mainowner_fullname')"
                      v-model="search.owner_apartment"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3" style="display: none">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-money"></i>
                    </div>
                    <lte-section-select2
                      @selectData="onSelectInvoiceStatus"
                      @unselectData="onUnselectInvoiceStatus"
                      :data="columnsInvoiceStatus.data_list"
                      :placeHolder="$t('common.status')"
                    ></lte-section-select2>
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <date-picker
                      v-model="datePickerValue"
                      @dp-change="onHandleChangeMonth(datePickerValue)"
                      :config="optionsPicker"
                      :placeholder="$t('invoice.issuePeriod')"
                    ></date-picker>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <dateRangePicker
                      :dateFormat="'DD/MM/YYYY'"
                      @applyDatePicker="emitApplyDatePicker"
                      @clearDatePicker="emitClearDatePicker"
                    />
                  </div>
                </div>

                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-filter"></i>
                    </div>
                    <select
                      class="form-control"
                      :placeholder="$t('apartmentGroup.title')"
                      v-model="search.status"
                    >
                      <option
                        v-for="(item, index) in invoiceStatusList"
                        :key="item+index"
                        :value="item.value"
                      >
                        {{ $t(item.text) }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
            </div> -->
            <div class="row">
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3"></div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <div class="form-group">
                <button
                  type="button"
                  class="btn btn-labeled btn-success pull-right"
                  @click="onSearchInvoice(defaultPage)"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <!-- <row style="margin: 0">
              <div style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;">
                <b>{{ $t("invoice.title") }}</b>
              </div>
            </row> -->
            <ul class="nav nav-tabs">
              <li class="active" @click="onClickTabSelect(TAB_ITEMS.INVOICE_LIST)">
                <a data-toggle="tab" id="serviceInvoiceTab" href="#serviceInvoiceManagement"><b>{{ $t("invoice.title") }}</b></a>
              </li>
              <li @click="onClickTabSelect(TAB_ITEMS.HISTORY)">
                <a data-toggle="tab" id="invoiceHistoryTab" href="#invoiceHistory"><b>{{ $t("common.history") }}</b></a>
              </li>
            </ul>

            <div class="tab-content">
              <div id="serviceInvoiceManagement" class="tab-pane fade in active">
                <servicesInvoiceManagement
                  ref="servicesInvoiceManagement"
                  @onChangeInvoiceType="onEmitSelectInvoiceType"
                />
              </div>
              <div id="invoiceHistory" class="tab-pane fade">
                <invoice-history ref="invoiceHistory" />
              </div>
            </div>
          </div>
          <div class="box-body"></div>
        </div>
        <!--  -->

        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar">
        </lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF">
        </loading>
      </row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import moment from "moment";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import Loading from "vue-loading-overlay";
import i18n from "../../lang";
import utils from '@/lib/utils';
import Enum from "../../../enum/enum"
import sectionselect2 from "@/components/LTESelect2Section";
import DateRangePicker from '@/components/LTEDateRangePickerCustom.vue'
import servicesInvoiceManagement from "./ServicesInvoiceManagement";
import InvoiceHistory from "./InvoiceHistory";

const TAB_ITEMS = {
  INVOICE_LIST: 0,
  HISTORY: 2
}

export default {
  name: "InvoiceList",
  data() {
    return {
      defaultPage: 1,
      check_fetchalldata: false,
      isPrintMonth: false,
      optionsPicker: {
        useCurrent: false,
        minDate: new Date(2019, 0),
        // maxDate: moment().format("YYYY/MM"),
        format: "YYYY/MM",
        locale: this.$i18n.locale == "en" ? "en" : "vi"
      },
      columnsInvoiceStatus: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false,
        isSelectInvoiceStatus: true
      },
      search: {
        invoice_number: "",
        apartment_code: "",
        owner_apartment: "",
        user_name: "",
        status_name: "",
        date_issued: "",
        date_paid: "",
        other_details: "",
        total_fees: "",
        due_date: "",
        note: "",
        dateCreatedInvoice: {
          start: null,
          end: null
        },
        status: null
      },
      invoiceHistorySearch: {
        searchText: null,
        userCreatedName: null,
        dateFrom: null,
        dateTo: null
      },
      datePickerValue: moment().format("YYYY/MM"),
      datePickerValueClone: null,
      isLoading: false,
      options: {
        format: "DD/MM/YYYY"
      },
      invoiceStatusSelect: [],
      list_invoice_id: [],
      isViewDetail: "False",
      dateViewOption: "DD/MM/YYYY",
      invoiceInformationList: [],
      isSelectedAll: false,
      multipleSendPdf: true,
      TAB_ITEMS: TAB_ITEMS,
      onTabSelect: TAB_ITEMS.INVOICE_LIST,
      manageInvoiceType: Enum.invoiceTypeEnum.MONTHLY,
      invoiceStatusList: [
        {
          value: null, text: '---'
        },
        {
          value: Enum.InvoiceStatusEnum.ACTIVATED, text: 'invoice.invoiceStatus.activated'
        },
        {
          value: Enum.InvoiceStatusEnum.OBSOLETE, text: 'invoice.invoiceStatus.obsoleted'
        },
        {
          value: Enum.InvoiceStatusEnum.DELETED, text: 'invoice.invoiceStatus.deleted'
        }
      ]
    };
  },
  watch: {
    GET_INVOICE_STATUS_DATA: function() {
      let params = this.$route.params;
      let data = this.GET_INVOICE_STATUS_DATA;
      let description = "";
      this.columnsInvoiceStatus.data_list = [];
      for (let i = 0, size = data.length; i < size; i++) {
        if (
          data[i].status_code == "O" ||
          data[i].status_code == "I" ||
          data[i].status_code == "P" ||
          data[i].status_code == "PP"
        ) {
          if (data[i].status_code == "O") {
            description = "invoice.invoice_status.O";
          } else if (data[i].status_code == "I") {
            description = "invoice.invoice_status.I";
          } else if (data[i].status_code == "P") {
            description = "invoice.invoice_status.P";
          } else if (data[i].status_code == "PP") {
            description = "invoice.invoice_status.PP";
          }
          if (this.isViewDetail == "True") {
            if (
              params.datasetLabel == this.$t("reportLiabilitiesReport.paid") &&
              (data[i].status_code == "P" || data[i].status_code == "PP")
            ) {
              this.invoiceStatusSelect.push(data[i].id);
              this.columnsInvoiceStatus.data_list.push({
                text: description,
                id: data[i].id,
                selected: "selected"
              });
            } else if (
              params.datasetLabel == this.$t("reportLiabilitiesReport.open") &&
              (data[i].status_code == "O" ||
                (data[i].status_code == "I" && data[i].status_code !== "C") ||
                (!utils.isNull(params.apartment) &&
                  data[i].status_code == "PP"))
            ) {
              this.invoiceStatusSelect.push(data[i].id);
              this.columnsInvoiceStatus.data_list.push({
                text: description,
                id: data[i].id,
                selected: "selected"
              });
            } else {
              this.columnsInvoiceStatus.data_list.push({
                text: description,
                id: data[i].id
              });
            }
            if (!utils.isNull(params.apartment)) {
              this.search.apartment_code = params.apartment;
            }
          } else {
            this.columnsInvoiceStatus.data_list.push({
              text: description,
              id: data[i].id
            });
          }
        }
      }
      if (this.isViewDetail == "True") {
        this.onSearchInvoice();
      }
    },
    GET_LANG: function() {
      this.optionsPicker.locale = this.$i18n.locale == "en" ? "en" : "vn";
      this.GET_INVOICE_STATUS_LIST();
      this.columnsInvoiceStatus.data_list = [];
    }
  },
  computed: {
    get_template: function() {
      if (utils.getProjectSession() == 1) {
        let template_list = [
          // { value: 1, text: "Template 01" },
          // { value: 2, text: "Template 02" },
          // { value: 3, text: "Template 03" },
          { value: 4, text: "Template 04" }
        ];
        return template_list;
      } else {
        let template_list = [{ value: 5, text: "Template default" }];
        return template_list;
      }
    },
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_LANG",
      "GET_INVOICE_STATUS_DATA"
    ])
  },

  methods: {
    getDataAllItem: function() {
      this.$refs.lteTable.selectAllIdInvoice();
    },
    showModalConfirmSendPdf: function(multipleSendPdf) {
      this.multipleSendPdf = multipleSendPdf;
      if (this.multipleSendPdf) {
        // if (this.isSelectedAll) {
        //     this.ON_SHOW_TOAST({
        //         message: 'Không thể gửi cho tất cả',
        //         styleType: "danger"
        //     });
        // } else
        if (this.invoiceInformationList.length > 0) {
          $(this.$refs["modal-confirm-send-pdf"]).modal("show");
        } else {
          this.ON_SHOW_TOAST({
            message: "Vui lòng chọn phiếu báo để gửi",
            styleType: "danger"
          });
        }
      } else {
        $(this.$refs["modal-confirm-send-pdf"]).modal("show");
      }
    },
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onSelectInvoiceStatus: function(data) {
      if (this.invoiceStatusSelect.indexOf(parseInt(data.id)) == -1) {
        this.invoiceStatusSelect.push(parseInt(data.id));
      }
    },
    onUnselectInvoiceStatus: function(data) {
      if (this.invoiceStatusSelect.indexOf(parseInt(data.id)) != -1) {
        this.invoiceStatusSelect.splice(
          this.invoiceStatusSelect.indexOf(parseInt(data.id)),
          1
        );
      }
    },
    getDataExportExcel(v) {
      let language_status_name =
        "invoice.invoice_status." + v["invoice.status_code"];
      let status_name = this.$t(language_status_name); //invoice.invoice_status.status_description;
      if (utils.isEnglishLanguage(i18n.locale)) {
        let data = {
          "Invoice Number": v["invoice.invoice_number"],
          "Apartment Code": v["invoice.apartment_code"],
          "Apartment Owner Information": utils.ucFirstAllWords(
            v["invoice.owner_apartment"]
          ),
          "User Name": utils.ucFirstAllWords(v["invoice.user_name"]),
          Status: status_name,
          "Date Issued": v["invoice.date_issued"],
          "Date Paid": v["invoice.date_paid"],
          //"Total Fees": utils.formatInteger( v["invoice.total_fees"]),
          "Tổng Phí": parseInt(v["invoice.total_fees"].replace(/,/g, "")),
          "Due Date": v["invoice.due_date"],
          Note: v["invoice.note"]
        };
        return data;
      } else {
        let data = {
          "Mã Thanh Toán": v["invoice.invoice_number"],
          "Mã Căn Hộ": v["invoice.apartment_code"],
          "Thông Tin Chủ Hộ": utils.ucFirstAllWords(
            v["invoice.owner_apartment"]
          ),
          "Xuất Hóa Đơn Tới": utils.ucFirstAllWords(v["invoice.user_name"]),
          "Tình Trạng": status_name,
          "Ngày Phát Hành": v["invoice.date_issued"],
          "Ngày Trả": v["invoice.date_paid"],
          //"Tổng Phí": utils.formatInteger( v["invoice.total_fees"]),
          "Tổng Phí": parseInt(v["invoice.total_fees"].replace(/,/g, "")),
          "Hạn Chót": v["invoice.due_date"],
          "Ghi Chú": v["invoice.note"]
        };
        return data;
      }
    },
    validateDateSearch: function () {
      let dataList = [
        this.search.invoice_number,
        this.search.apartment_code,
        this.search.owner_apartment,
        this.search.dateCreatedInvoice.start]
      let findIsNull = dataList.find( x=> { if (!utils.isEmptyString(x)) return x } )
      if (findIsNull === undefined) {
        this.datePickerValue = this.datePickerValueClone
      }
    },
    onSearchInvoice() {
      this.validateDateSearch()
      let data = {
        invoice_type: this.manageInvoiceType,
        invoice_number: this.search.invoice_number,
        apartment_code: !utils.isEmptyString(this.search.apartment_code) ? this.search.apartment_code.toUpperCase() : null,
        owner_apartment: this.search.owner_apartment,
        user_name: this.search.user_name,
        date_issued: this.search.date_issued,
        date_paid: this.search.date_paid,
        other_details: this.search.other_details,
        total_fees: this.search.total_fees,
        due_date: this.search.due_date,
        note: this.search.note,
        period: "", // TODO: Sep21 need to remove this.search.period,
        datePickerValue: utils.formatSqlDate(this.datePickerValue, "YYYY/MM", "YYYYMM"),
        dateCreatedInvoiceFrom: this.search.dateCreatedInvoice.start,
        dateCreatedInvoiceTo: this.search.dateCreatedInvoice.end,
        invoiceStatus: this.search.status
      };
      let value = this.onTabSelect;
      switch (value) {
        case TAB_ITEMS.INVOICE_LIST:
          this.setQueryRouter()
          if (this.$refs.servicesInvoiceManagement !== undefined) {
            this.$refs.servicesInvoiceManagement.onRefsDataSearch(data);
          }
          break;

        case TAB_ITEMS.HISTORY:
          if (this.$refs.invoiceHistory !== undefined) {
            this.$refs.invoiceHistory.onRefreshData(this.invoiceHistorySearch);
          }
          this.$router.replace({
            query: {
              onTabSelect: this.onTabSelect
            }
          });
          break;

        default:
          break;
      }
    },
    setQueryRouter: function() {
      this.$router.replace({
        query: {
          invoiceNumber: this.search.invoice_number,
          apartmentCode: !utils.isEmptyString(this.search.apartment_code)
            ? this.search.apartment_code.toUpperCase() : null,
          ownerApartment: this.search.owner_apartment,
          datePickerValue: this.datePickerValue,
          invoiceType: this.manageInvoiceType,
          onTabSelect: this.onTabSelect,
          invoiceStatus: this.search.status
        }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw error;
        }
      });
    },
    getQueryRouter: function() {
      let routerQuery = this.$route.query;
      let invoiceNumber = routerQuery && routerQuery.invoiceNumber
      let apartmentCode = routerQuery && routerQuery.apartmentCode
      let ownerApartment = routerQuery && routerQuery.ownerApartment
      let datePickerValue = routerQuery && routerQuery.datePickerValue
      let invoiceStatus = routerQuery && routerQuery.invoiceStatus
      let invoiceType = routerQuery && routerQuery.invoiceType
      this.search.invoice_number = utils.getCleanStringValue(invoiceNumber)
      this.search.apartment_code = utils.getCleanStringValue(apartmentCode)
      this.search.owner_apartment = utils.getCleanStringValue(ownerApartment)
      this.datePickerValue = utils.getCleanStringValue(datePickerValue, this.datePickerValue)
      this.search.status = utils.getCleanStringValue(invoiceStatus)
      if (invoiceType != undefined) {
        this.manageInvoiceType = parseInt(invoiceType);
      }
    },
    onHandleChangeMonth: function(value) {
      this.datePickerValueClone = utils.getCleanStringValue(this.datePickerValue, this.datePickerValueClone)
    },
    onClickTabSelect: function(value) {
      this.onTabSelect = value;
      this.onSearchInvoice();
    },
    onShowTabSelect: function() {
      let value = this.onTabSelect;
      switch (value) {
        case TAB_ITEMS.INVOICE_LIST:
          this.activaTab("serviceInvoiceTab");
          this.onSearchInvoice();
          break;

        case TAB_ITEMS.HISTORY:
          this.activaTab("invoiceHistoryTab");
          this.$refs.invoiceHistory.onRefreshData(this.invoiceHistorySearch);
          break;

        default:
          break;
      }
    },
    onEmitSelectInvoiceType: function(invoiceType) {
      this.manageInvoiceType = invoiceType
      this.setQueryRouter()
    },
    activaTab(tab) {
      $('.nav-tabs a[id="' + tab + '"]').tab("show");
    },
    emitApplyDatePicker: function(data) {
      this.search.dateCreatedInvoice.start = data.start_date
      this.search.dateCreatedInvoice.end = data.end_date
    },
    emitClearDatePicker: function(data) {
      this.search.dateCreatedInvoice.start = data.start_date
      this.search.dateCreatedInvoice.end = data.end_date
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_INVOICE_STATUS_LIST"
    ])
  },
  created() {
    let params = this.$route.params;
    this.isViewDetail = !utils.isNull(params.isViewDetail) ? params.isViewDetail : "False";
    this.dateViewOption = sessionStorage.getItem('projectDateViewOptions');
    if (this.isViewDetail == "True") {
      this.options.format = this.dateViewOption.slice(3);
    } else {
      this.options.format = this.dateViewOption;
    }
    this.GET_INVOICE_STATUS_LIST();
  },
  async mounted() {
    let onTabSelect = this.$route.query.onTabSelect;
    if (onTabSelect != undefined) {
      this.onTabSelect = parseInt(onTabSelect);
    }
    this.getQueryRouter()
    this.datePickerValueClone = this.datePickerValue
    //
    await this.onShowTabSelect();
    // await this.onSearchInvoice();
  },

  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    loading: Loading,
    "lte-section-select2": sectionselect2,
    servicesInvoiceManagement,
    InvoiceHistory,
    DateRangePicker
  }
};
</script>

<style lang="scss" scoped>
.search {
  box-shadow: none;
  border-color: #d2d6de;
  z-index: 2;
  float: left;
  margin-bottom: 8px;
  margin-right: 5px;
  height: 30px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.select-option-invoice {
  margin-top: -12px;
  display: inline-block;
}
@media only screen and (max-width: 1000px) {
  .select-option-invoice {
    float: none;
    margin-top: 4px;
  }
}
@media only screen and (max-width: 768px) {
  .select-option-invoice {
    float: none;
    margin-top: 0px;
  }
}

.size-180 {
  width: 180px;
}

.label_choose_print {
  margin-bottom: 2%;
}

#checkboxesInvoice {
  display: flex;
  margin-top: 3%;
}

.checkbox_has_amount {
  display: inline;
  margin-right: 2rem;
}
.search-tools {
  padding-right: 0px;
  padding-left: 0px;
  width: auto;
}

.nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
  background: #337ab7;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/Invoice/InvoiceListV2.vue